import {
  chakraComponents,
  GroupBase,
  IndicatorsContainerProps,
} from 'chakra-react-select';
import { ReactComponent as CloseIcon } from 'resources/images/close.svg';
import { ReactComponent as TooltipIcon } from 'resources/images/info.svg';
import { Box, Flex, HStack, Icon, Tooltip } from '@chakra-ui/react';

export const IndicatorsContainer = <Option extends {}>({
  children,
  ...props
}: IndicatorsContainerProps<Option, false, GroupBase<Option>>) => {
  const { hasValue, selectProps, clearValue } = props;
  const {
    inputValue,
    isClearable,
    menuIsOpen,
    customComponentsProps,
    tooltip,
    onInputChange,
  } = selectProps;
  const showClearButton =
    (inputValue || (hasValue && isClearable)) && menuIsOpen;

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onInputChange('', {
      action: 'input-change',
      prevInputValue: inputValue,
    });
    if (isClearable) {
      clearValue();
    }
  };

  return (
    <chakraComponents.IndicatorsContainer {...props}>
      {children}
      {showClearButton && (
        <HStack
          height="100%"
          paddingLeft={2}
          cursor="pointer"
          onTouchEnd={handleClick}
          onClick={handleClick}
        >
          <CloseIcon width={20} height={20} color="var(--chakra-colors-M-60)" />
        </HStack>
      )}
      {tooltip && (
        <Box paddingLeft={2} data-testid="tooltip-icon">
          <Tooltip label={tooltip} hasArrow>
            <Icon as={TooltipIcon} color="iconBase" w={5} h={5} />
          </Tooltip>
        </Box>
      )}
      {customComponentsProps?.inputRightElement && (
        <Flex paddingLeft={2} alignItems="center">
          {customComponentsProps.inputRightElement}
        </Flex>
      )}
    </chakraComponents.IndicatorsContainer>
  );
};
